import React from 'react';
import Box from "../../Common/Box";
import ThreeScreen from "../ThreeScreen";
import ScDrawer from "../../Common/ScDrawer";
import uiStore from "../../lib/stores/uiStore";
import Paper from "@mui/material/Paper";
import Settings from "../../UserSettings/UserSettings";
import Messages from "../../Messages/Messages";
import UserList from "../../Room/UserList";
import Notification from "../../Common/Notification";
import MobileRoomList from "../../RoomList/MobileRoomList";
import MobileUserInfo from "../../Common/UserInfo/MobileUserInfo";
import ManagerButtons from "../../AppManager/ManagerButtons";
import shadowClient from "../../lib/clients/shadow/shadowClient";
import {observer} from "mobx-react";
import Navbar from "./Navbar";
import MobileReactionPanel from "../../Messages/ReactionPanel/MobileReactionPanel";

const MobileMain = () => {

    const clientUser = shadowClient.getClientUser();

    return <Box column height={"100%"}>
        {/* <Navbar/> */}
        <Box flex={1} width={"100%"} overflow={"auto"} position={"relative"}>
            <Box position={"absolute"} expand>
                <ThreeScreen/>
            </Box>
            <div
                    id={"drawer-container"}
                    style={{
                        height: "100%",
                        position: "absolute",
                        width: "100%",
                        right: "0",
                    }}>
                <ScDrawer
                        onLeftOpen={() => {
                            uiStore.settingsVisible = true;
                            uiStore.userListVisible = false;
                        }}
                        onRightOpen={() => {
                            uiStore.settingsVisible = false;
                            uiStore.userListVisible = true
                        }}
                        onClose={() => {
                            uiStore.settingsVisible = false;
                            uiStore.userListVisible = false;
                        }}
                        leftOpen={uiStore.settingsVisible}
                        rightOpen={uiStore.userListVisible}
                        rightVisibleEdgeWidth={60}
                >
                    <Box marginLeft={"-150%"} width={"400%"} height={"100%"} row>

                        <Paper
                                elevation={5}
                                sx={{
                                    pointerEvents: "all",
                                    flex: 1.5,
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-end",
                                }}>
                            {clientUser &&
                                    <Settings sx={{width: (2 / 3 * 100) + "%"}} clientUser={clientUser}/>}
                        </Paper>
                        <div style={{
                            height: "100%",
                            // width: "100%",
                            flex: 1,
                            position: "relative",
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column",
                        }}>
                            <Navbar/>
                            <Messages/>
                        </div>
                        <Paper
                                elevation={5}
                                sx={{
                                    flex: 1.5,
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                }}>
                            <UserList sx={{width: "100%"}}/>
                        </Paper>
                    </Box>
                </ScDrawer>
            </div>
            <Notification/>
        </Box>

        <MobileRoomList/>
        <MobileUserInfo/>
        <MobileReactionPanel/>
        {uiStore.appManagerEnabled && <ManagerButtons/>}
    </Box>
};

export default observer(MobileMain);
